// extracted by mini-css-extract-plugin
export var cardIcon = "_8c-4";
export var checkboxCard = "_8c-0";
export var checkboxCardSelected = "_8c-3";
export var disabled = "_8c-1";
export var outerBorder = "_8c-2";
export var spacerMedium = "_8c-7";
export var spacerSmall = "_8c-6";
export var spacerXsmall = "_8c-5";